import { atom } from "recoil";

export const socketState = atom({
  key: `socketState`,
  default: { socket: 0, e: null },
});
